import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Table,
  Row,
  Col,
  Input,
  Button,
  ButtonGroup,
  Label
} from 'reactstrap';
import { Scatter } from 'react-chartjs-2';

import chartOptions from './utils/chartOptions';
import chartData from './utils/chartData';
import OutputCalc from '../../../../../../../../components/UIComponents/Fields/OutputCalc';
import optionsStrainUnits from '../../../../../../../../utils/units/optionsStrainUnits';

class ResultsUls extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graphLarge: 1
    };
  }

  render() {
    const {
      uls,
      concrete,
      reinforcement
    } = this.props;

    const {
      graphLarge
    } = this.state;
    return (
      <Container className="geometry">
        <br />
        <div id="scrollmenu">
          <Row>
            <Col md={graphLarge === 1 ? 6 : 12}>
              <div className="controlChart">
                <i
                  className="material-icons"
                  onClick={() => this.setState({ graphLarge: -graphLarge })}
                >
                  {graphLarge === 1 ? 'crop_free' : 'crop'}
                </i>
              </div>
              <div className="chartLargeContainer">
                <Scatter
                  className="chart"
                  width={1000}
                  height={1000}
                  data={chartData(concrete.sectionext, concrete.sectionint, uls)}
                  options={chartOptions(concrete.sectionext, reinforcement.unit, reinforcement.geometry)}
                />
                <br />
              </div>
            </Col>
            <Col md={graphLarge === 1 ? 6 : 12}>
              <h2 className="subtitle">Strain in Concrete</h2>
              {/* <OutputCalc
                input={sls.resExtremStress.concrete.sigmacmin}
                unitList={optionsStressUnits}
              /> */}
              <OutputCalc
                input={uls.resExtremStrain.concrete.epsicmax}
                unitList={optionsStrainUnits}
              />
              <h2 className="subtitle">Strain in Reinforcement</h2>
              <OutputCalc
                input={uls.resExtremStrain.steel.epsismax}
                unitList={optionsStrainUnits}
              />
              <Table responsive>
                <thead>
                  <tr className="column">
                    <th>{`x(${reinforcement.unit.text})`}</th>
                    <th>{`y(${reinforcement.unit.text})`}</th>
                    <th>number</th>
                    <th>{`diameter(${reinforcement.unitDiameter.text})`}</th>
                    <th>{`strain(${uls.resExtremStrain.steel.epsir.unitStrain})`}</th>
                  </tr>
                </thead>
                <tbody>
                  {uls.resExtremStrain.steel.epsir.geometry.map((coordinate, index) => (
                    <tr key={index}>
                      <td className="tableTd">
                        <Input value={coordinate.x} type="number" />
                      </td>
                      <td className="tableTd">
                        <Input value={coordinate.y} type="number" />
                      </td>
                      <td className="tableTd">
                        <Input value={coordinate.number} type="number" />
                      </td>
                      <td className="tableTd">
                        <Input value={coordinate.diameter} type="number" />
                      </td>
                      <td className="tableTd">
                        <Input value={Math.round(coordinate.strain * 1000) / 1000} type="number" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </div>
      </Container>
    );
  }
}

export default ResultsUls;
